import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import { MedicalAidSeoDetailCard } from './SeoDetailMedicalAidModuleShared';

const SeoDetailMedicalAidModuleComponent = ({ data }) => {
  if (!data) return null;

  const { title, description, footer, sections = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',

        px: { xs: '16px', md: '24px' },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1010px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0px',
          overflow: 'visible',
          boxSizing: 'border-box',
          pb: { xs: '0px', md: '30px' },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '804px',
            bottom: 0,
            backgroundColor: '#E3E6E8',
            borderRadius: '48px',
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            width: '100%',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: { xs: '100%', md: '738px' },
              px: { xs: '24px', md: '0px' },
              pt: { xs: '36px', md: '44px' },
              pb: { xs: '88px', md: '0px' },
              boxSizing: 'border-box',
              mx: 'auto',
            }}
          >
            <ScrollFadeWrapper variant="text">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: { xs: '12px', md: '20px' },
                  textAlign: 'center',
                }}
              >
                <Typography
                  component="h2"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    fontSize: { xs: '2.5rem', md: '3rem' },
                    lineHeight: { xs: '2.75rem', md: '3.25rem' },
                    letterSpacing: '-0.04em',
                    color: '#162F3B',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {title}
                </Typography>

                <Typography
                  component="p"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: { xs: '1.125rem', md: '1.5rem' },
                    lineHeight: { xs: '1.625rem', md: '1.75rem' },
                    letterSpacing: '-0.03em',
                    color: '#162F3B',
                    whiteSpace: 'pre-line',
                    maxWidth: '1260px',
                  }}
                >
                  {description}
                </Typography>
              </Box>
            </ScrollFadeWrapper>
          </Box>

          <Box
            sx={{
              width: '1010px',
              boxSizing: 'border-box',
              mt: { xs: '-29px', md: '68px' },
              position: 'relative',
              zIndex: 1,
              mx: 'auto',
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
              }}
            >
              {sections.map((section, index) => (
                <ScrollFadeWrapper
                  key={section.title || index}
                  delay={index * 0.15}
                >
                  <MedicalAidSeoDetailCard section={section} isDesktop />
                </ScrollFadeWrapper>
              ))}
            </Box>
          </Box>
        </Box>

        {footer ? (
          <Typography
            sx={{
              textAlign: 'center',
              fontFamily: 'Inter, sans-serif',
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '1.5rem',
              letterSpacing: '-0.02em',
              color: '#162F3B',
              maxWidth: '473px',
              mt: '8px',
            }}
          >
            {footer}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default SeoDetailMedicalAidModuleComponent;
